import React, { memo, useEffect } from "react";
import { useCameraContext } from "../context/CameraContext";

const Timer: React.FC = memo(() => {
  const { state } = useCameraContext();




  if (!state.showTimer) {
    return null;
  }

  return (
    <div className="fixed z-50 transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
      <div className="flex items-center justify-center w-32 h-32 bg-black rounded-full bg-opacity-80">
        <span className="text-6xl font-bold text-white animate-pulse">{state.timerCount}</span>
      </div>
    </div>
  );
});

Timer.displayName = "Timer";

export default Timer;
